import {gql} from '@apollo/client';

export const ASSIGN_TICKET = gql`
  mutation AssignTicket($input: AssignTicketInput!) {
    assignTicket(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicket {
        message
        data {
          id
          status
          assignedAgentId
          assignedAgentName
          assignedAt
        }
      }
    }
  }
`;

export const ADD_TICKET_EVENT = gql`
  mutation AddTicketEvent($input: AddTicketEventInput!) {
    addTicketEvent(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicketEvent {
        message
        data {
          id
          eventType
          payload
          createdAt
        }
      }
    }
  }
`;

export const RESOLVE_TICKET = gql`
  mutation ResolveTicket($input: ResolveTicketInput!) {
    resolveTicket(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicket {
        message
        data {
          id
          status
          resolvedAt
          csatScore
          resolutionType
        }
      }
    }
  }
`;

export const UPDATE_TICKET_STATUS = gql`
  mutation UpdateTicketStatus($input: UpdateTicketStatusInput!) {
    updateTicketStatus(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicket {
        message
        data {
          id
          status
        }
      }
    }
  }
`;

export const LINK_TICKET_TO_USER = gql`
  mutation LinkTicketToUser($input: LinkTicketToUserInput!) {
    linkTicketToUser(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicket {
        message
        data {
          id
          userId
          origin
          linkedAt
          linkedByAgentId
          user {
            id
            firstName
            lastName
            email
            imageUrl
          }
        }
      }
    }
  }
`;

export const UNLINK_TICKET_FROM_USER = gql`
  mutation UnlinkTicketFromUser($input: UnlinkTicketFromUserInput!) {
    unlinkTicketFromUser(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithHelpdeskTicket {
        message
        data {
          id
          userId
          origin
          linkedAt
          linkedByAgentId
        }
      }
    }
  }
`;

export const REGISTER_ADMIN_PUSH_SUBSCRIPTION = gql`
  mutation RegisterAdminPushSubscription(
    $input: RegisterAdminPushSubscriptionInput!
  ) {
    registerAdminPushSubscription(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminPushStatus {
        message
        data {
          subscribed
        }
      }
    }
  }
`;

export const UNREGISTER_ADMIN_PUSH_SUBSCRIPTION = gql`
  mutation UnregisterAdminPushSubscription(
    $input: UnregisterAdminPushSubscriptionInput!
  ) {
    unregisterAdminPushSubscription(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminPushStatus {
        message
        data {
          subscribed
        }
      }
    }
  }
`;

export const SEND_TEST_ADMIN_PUSH = gql`
  mutation SendTestAdminPush {
    sendTestAdminPush {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAdminPushStatus {
        message
        data {
          delivered
        }
      }
    }
  }
`;
